const dayMillis = 86400000
const hourMillis = 3600000
const minuteMillis = 60000
const secondMillis = 1000

export default class CountDownTimer {
  /**
   *
   * @param millisInFuture 时间毫秒数
   * @param countDownInterval 时间毫秒数（单位间隔）
   */
  constructor(millisInFuture, countDownInterval) {
    this.millisInFuture = millisInFuture
    this.mInterval = countDownInterval
    this.onFinishListener = () => {
    }
    this.onCountDownListener = (time) => {
    }
    this.timer = undefined
  }

  start() {
    if (!this.timer) {
      let that = this
      this.timer = setInterval(() => {
        that.millisInFuture = that.millisInFuture - that.mInterval
        if (that.millisInFuture > 0) {
          that.onCountDownListener(CountDownTimer.getTimeInfo(that.millisInFuture))
        } else {
          that.cancel()
          that.onFinishListener()
        }
      }, that.mInterval)
    }
  }

  cancel() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = undefined
    }
  }

  static getTimeInfo(time) {
    let hourTime = time % dayMillis//剩余的小时部分时间
    let minuteTime = time % hourMillis//剩余的分钟部分时间
    let secondTime = time % minuteMillis//剩余的秒部分时间
    return {
      time: time,
      day: Math.floor(time / dayMillis),
      hour: Math.floor(hourTime / hourMillis),
      minute: Math.floor(minuteTime / minuteMillis),
      second: Math.floor(secondTime / secondMillis),
      format: (value) => {
        return value >= 10 ? value : '0' + value
      }
    }
  }
}

